module.exports = __webpack_public_path__ + "images/editDarkBg.494c240c.svg";